<style lang="less" rel="stylesheet/less" scope>
  body {
    background-color: #fff;
  }
  .recover-wrapper {
    .content {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 600px;
      min-height: 450px;
      padding: 15px;
      margin-top: -275px;
      margin-left: -300px;
    }
  }
</style>
<template>
  <div class="recover-wrapper">
    <ly-layout-platform></ly-layout-platform>
    <div class="content">
      <el-form class="content-form" :model="formData" ref="formData" :rules="rules" label-width="100px">
        <el-form-item label="用户名：" required prop="loginName">
          <el-input
            placeholder="请输入用户名"
            v-model.trim="formData.loginName" type="loginName" v-input-trim></el-input>
        </el-form-item>
        <el-form-item label="邮箱：" required prop="email">
          <el-input
            placeholder="请输入邮箱"
            v-model.trim="formData.email" v-input-trim></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="makeSure('formData')">保 存</el-button>
          <router-link tag="button" class="el-button el-button--default el-button--small" :to="{name: 'login'}">
            <span>取 消</span>
          </router-link>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script type='text/ecmascript-6'>
  import { sendMail } from '@/api/login'
  import { recover } from '@/utils/rule-mixin'

  export default  {
    data() {
      return {
        formData: {
          email: '',
          loginName: '',
        },
        rules: recover
      }
    },
    created() {
      this.popupMsg();
    },
    methods: {
      popupMsg() {
        this.$message({
          message: '请输入正确的用户名和邮箱地址以便您找回密码',
          type: 'warning',
          duration: 3000
        })
      },
      makeSure(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            sendMail(Object.assign({}, this.formData)).then(res => {
              if (res.code === '200') {
                this.$message({
                  message: '系统已发送最新密码到您邮箱,请重新登录',
                  onClose: () => {
                    localStorage.clear();
                    sessionStorage.clear();
                    this.$router.push({name: 'login'});
                  }
                })
              } else {
                this.$message({
                  message: res.message,
                  type: 'error'
                })
              }
            })
          } else {
            return false;
          }
        });
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/views/login/recover.vue